<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-10-22 10:37:09
 * @LastEditors: voanit
 * @LastEditTime: 2021-11-23 16:22:31
-->
<template>
  <div>
    <error-content :code="$t('system::common::expired-code')" :desc="$t('system::common::expired-desc')" :src="src">
      <!-- 当前商家是该账号下才有跳转 -->
      <div slot="btn_back" style="margin-top:24px" v-show="isOwnMerchant">
        <el-button type="primary" @click="toUrl">{{ $t('system::common::expired-btn') }}</el-button>
      </div>
    </error-content>
  </div>
</template>

<script>
import { getUserSystem } from '@/server/personal/contract'
import errorContent from './error-content.vue'
import { _local } from '@/utils/storage'
import { toPersonalPage } from '@/utils/index'
export default {
  name: 'expired',
  components: {
    errorContent
  },
  data() {
    return {
      src: require('@/assets/images/expired.png')
    }
  },
  computed: {
    isOwnMerchant() {
      return this.$store.getters.getIsOwnMerchant
    }
  },
  mounted() {
    // 为了判断购买了套餐后，从个人中心跳出能回到首页
    this.getUser()
  },
  methods: {
    async getUser() {
      const { data } = await getUserSystem({ merchantId: this.$store.state.user.merchantId })
      if (data.code === this.$code) {
        this.$store.commit(
          'user.setSystemStatus',
          (data.data || [])
            .filter(el => el.enabled)
            .map(el => el.systemId)
            .join(',')
        )
        data.data.forEach(el => {
          if (el.systemId === 3 && el.enabled) {
            this.$store.commit('setIsExpired', false)
            this.$router.replace('/')
          }
        })
      }
    },
    toUrl() {
      _local.set('backUrl', this.$route.name === 'expired' ? window.location.origin : window.location.href)
      // this.$router.push('/open-contract')
      toPersonalPage()
    }
  }
}
</script>
